export default {
  "b2b.provozni-informace-cards.empty": "No operational information",
  "b2b.provozni-informace-card.delete-dialog.title":
    "Delete operational information",
  "b2b.provozni-informace-card.delete-dialog.confrimMessage":
    "Do you really want to delete the operational information?"
};
